import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=5d9f2018&"
import script from "./Workbench.vue?vue&type=script&lang=ts&"
export * from "./Workbench.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports